const translations = {
    'settings.configTitle': 'Configuration (JSON)',
    'settings.editHint': 'Edit in the panel below.',
    'settings.error': 'Error: %s',
    'settings.invalidJson': 'Invalid JSON',
    'settings.overlayLabel': 'Config JSON',
    'settings.reset': 'Reset',
    'settings.save': 'Save',
    'settings.storageHint': 'Config is stored in localStorage.',
    'settings.tabConfig': 'Config',
    'settings.tabAudio': 'Audio',
    'settings.audio.title': 'Audio',
    'settings.audio.background': 'Background',
    'settings.audio.bell': 'Bell',
    'settings.audio.hit': 'Hit loop',
    'settings.audio.on': 'On',
    'settings.audio.off': 'Off',
    'settings.audio.toggle': 'Toggle',
    'settings.audio.setVolume': 'Set volume',
    'settings.audio.status': '%s: %s (vol %s)',
    'settings.audio.volumePrompt': 'Set %s volume (0-1):',
    'settings.title': 'Settings',
};

export default translations;
